import React from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { loginUser } from "../../Redux/Authentication/AuthenticationAction";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { googleLogin, login, resetPassword, sendOtp } from "../../Api/apiService";
import { ToastContainer, toast } from "react-toastify";
import InputValidator, { validationPatterns, validTLDs } from "../../Validation/constant";

import warningIcon from "../../Images/icons/warning-svg-icon.svg"
import ModalNew from "../../Components/Modal/modal-new";
import CustomInput from "../../Components/Input/Custom-Input";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import CustomizeButton from "../../Components/Button/Customize-Button";
import { GoogleLogin } from "@react-oauth/google";
function Login() {
  const [selectedRole, setSelectedRole] = useState("ROLE_EMPLOYEE");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [credentialEmailError, setCredentialEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [emailForgetPassword, setEmailForgetPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const [formError, setFormError] = useState({
    errorEmail: "",
    errorPassword: "",
  });

    const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

   const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth && auth.token) {
      if (auth.role === "ROLE_EMPLOYEE") {
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } else if (auth.role === "ROLE_HR") {
        setSelectedRole("ROLE_HR");
        setTimeout(() => {
          navigate("/dashboardHr");
        }, 2000);
      }
    }
  }, [auth]);



   const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear specific field error while typing
    setFormError((prev) => ({ ...prev, [`error${name.charAt(0).toUpperCase() + name.slice(1)}`]: "" }));
  };


    const handleGoogleSuccess= async (credentialResponse)=>{

     console.log("Google Login Success:", credentialResponse);

     try {
     const response = await googleLogin(credentialResponse?.credential);
       if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "Login successful.", { autoClose: 2000 });
        dispatch(loginUser(response.data));
        window.localStorage.setItem("authtoken", response.data.token);
      }
    }catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", { autoClose: 2000 });
    }

  }

    const handleLogin = async (e) => {
    e.preventDefault();

    // validate inputs
    const emailError = InputValidator.isValidLoginEmail(formData.email);
    const passwordError = InputValidator.isValidPassword(formData.password);

    setFormError({
      errorEmail: emailError,
      errorPassword: passwordError,
    });

    console.log(formError, "form error");

  

    try {
      const encodedPassword = btoa(formData.password);
      const response = await login(formData.email, encodedPassword);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "Login successful.", { autoClose: 2000 });
        dispatch(loginUser(response.data));
        window.localStorage.setItem("authtoken", response.data.token);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", { autoClose: 2000 });
    }
  };

  const validateCredentialEmail = () => {
    if (selectedRole === "admin") {
      if (!validationPatterns.email.test(email)) {
        setCredentialEmailError("Please enter a valid email.");
        return false;
      }
      const emailTLD = email.substring(email.lastIndexOf("."));
      if (!validTLDs.includes(emailTLD)) {
        setCredentialEmailError(`Email must end with a valid domain`);
        return false;
      }
    }
    setCredentialEmailError("");
    return true;
  };
   const submitChangePassword = async () => {
    try {
      const response = await resetPassword(emailForgetPassword, otp, btoa(newPassword));
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "Password reset successfully.", { autoClose: 2000 });
        setTimeout(() => (window.location.href = "/"), 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", { autoClose: 2000 });
    }
  };

  const handleSendOtp = async () => {
     if (!emailForgetPassword || emailForgetPassword.trim() === "") {
    toast.warning("Please enter email", { autoClose: 2000 });
    return;
  }
    try {
      const response = await sendOtp(emailForgetPassword);
      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "OTP sent successfully.", { autoClose: 2000 });
        setTimeout(() => {
          setShowEmailModal(false);
          setShowChangePasswordModal(true);
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", { autoClose: 2000 });
    }
  };




    const handleGoogleError = () => {
    toast.error("Google login failed. Please try again.");
  };

  const onCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  const onCloseChangePasswordModal = () => {
    setShowChangePasswordModal(false);
  };

  const handleForgetPassword = () => {
    setShowEmailModal(true);
  };

  return (

    <>
      <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">Login</h1>
        <p className="login-subtitle">Welcome to Resume Builder</p>
         <form onSubmit={handleLogin}>
          <div className="form-group">
            <div className="input-container">
              <input
                type="email"
                className={`form-input ${formError.errorEmail ? "error" : ""}`}
                placeholder={
                  formError.errorEmail ? formError.errorEmail : "Email"
                }
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {formError.errorEmail && (
                <img
                  src={warningIcon}
                  alt="error"
                  className={`warning-icon ${
                    formError.errorEmail ? "error" : ""
                  }`}
                />
              )}
            </div>
          </div>
          <div className="form-group">
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-input ${
                  formError.errorPassword ? "error" : ""
                }`}
                placeholder={
                  formError.errorPassword ? formError.errorPassword : "Password"
                }
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={togglePassword}
              >
                <svg className="eye-icon" viewBox="0 0 24 24">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                </svg>
              </button>
            </div>
          </div>
           <button type="submit" className="login-button">
            Login
          </button>
         </form>
           <a onClick={handleForgetPassword} href="#" className="forgot-password">
          Forgot Password?
        </a>
           <div className="divider">Or</div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap
            text="signin_with"
            size="large"
            width="100%"
          />
        </div>
      
         
      </div>
     </div> 
    
    <ModalNew
      title={"Forgot Password"}
       visible={showEmailModal}
       onClose={onCloseEmailModal}
    >
      <div style={{
        display:"flex",
        flexDirection:"column",
        gap:"10px",
      }}>
       <div>
       <InputWrapper label="Enter Email" required>
        <CustomInput  className="role-selector" value={emailForgetPassword}   onChange={(e) => setEmailForgetPassword(e.target.value)} ></CustomInput>
       </InputWrapper>
       </div>

         <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>

        <CustomizeButton className="navigate-btn" onClick={handleSendOtp}> Send OTP</CustomizeButton>
        <CustomizeButton variant="outlined" className="navigate-btn" onClick={()=>{
          setShowEmailModal(false);
        }}>Cancel</CustomizeButton>

       </div>
     
     </div>
    </ModalNew>
    <ModalNew
    title={"Enter New Password"}
  visible={showChangePasswordModal}
  onClose={onCloseChangePasswordModal}
>
  <div style={{
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  }}>
    <div>
      <InputWrapper label="Enter Email">
        <CustomInput
          className="role-selector"
          type="email"
          value={emailForgetPassword}
          onChange={(e) => setEmailForgetPassword(e.target.value)}
        />
      </InputWrapper>
    </div>

    <div>
      <InputWrapper label="Enter OTP">
        <CustomInput
          className="role-selector"
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
      </InputWrapper>
    </div>

    <div>
      <InputWrapper label="Enter New Password">
        <CustomInput
          className="role-selector"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </InputWrapper>
    </div>

     <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
      <CustomizeButton className="navigate-btn" onClick={submitChangePassword}>
        Submit
      </CustomizeButton>
      <CustomizeButton className="navigate-btn" onClick={()=>{
        setShowChangePasswordModal(false);
      }}  variant="outlined">
        Cancel
      </CustomizeButton>
    </div>
  </div>
</ModalNew>

    <ToastContainer />
    </>

      
      
  
  );
}

export default Login;
